(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('NormaSearch', NormaSearch);

    NormaSearch.$inject = ['$resource'];

    function NormaSearch($resource) {
        var resourceUrl =  'public/api/_search/normas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
